module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "pref03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("ILLUSTRATIONS")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch02#ch02fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Icebreaker towing YOG through pack ice,"), _c('br'), _vm._v("with helicopter scouting ice conditions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch02#ch02fig02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Icebreaker "), _c('em', [_vm._v("Glacier")]), _vm._v(" leading convoy of ships through"), _c('br'), _vm._v("Ross Sea pack ice, December 1955")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wheels-only R5D and dog team on"), _c('br'), _vm._v("ice of McMurdo Sound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seabees’ first tent camp huddled around"), _c('br'), _vm._v("Scott’s 1902 storage hut")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modular Clements huts under construction at McMurdo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOGs 34 and 70 moored along outer side of Hut Point")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Father John Condit and cook Ray Spiers"), _c('br'), _vm._v("entertain McMurdo’s winterers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Members of the wedding—“Grace Kelly’s"), _c('br'), _vm._v("Wedding,” produced by Father Condit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camping out with South Pole gear, a survival training exercise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch03#ch03fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plowing McMurdo’s ice runway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch04#ch04fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mooring cargo ship USS "), _c('em', [_vm._v("Arneb")]), _vm._v(" to bay ice using “deadmen”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch04#ch04fig02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Off-loading "), _c('em', [_vm._v("Arneb")]), _vm._v(" onto bay ice in Kainan Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch04#ch04fig03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Clements hut under construction at Little America V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch04#ch04fig04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aircraft landed in a whiteout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch04#ch04fig05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little America V already drifting in, April 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch05#ch05fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First tractor train en route from Little America to"), _c('br'), _vm._v("build Byrd Station")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch06#ch06fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Air Force C-124 disgorging a tractor at McMurdo Sound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch06#ch06fig02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beardmore Auxiliary Station being established to"), _c('br'), _vm._v("support Pole-bound flights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch06#ch06fig03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First South Pole landing, 31 October 1956")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch06#ch06fig04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First tent camp at the South Pole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch06#ch06fig05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laying floor panels atop foundation timbers for South Pole garage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch06#ch06fig06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Airdrop of fuel over the South Pole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch06#ch06fig07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South Pole Station, nearly completed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch06#ch06fig08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dignitaries at dedication of Amundsen-Scott South Pole"), _c('br'), _vm._v("Station at McMurdo, 23 January 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch07#ch07fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hallett Station showing boat landing ramp and"), _c('br'), _vm._v("“penguin-proof” fence made of fuel barrels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch07#ch07fig02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Displaced Adélie penguins in rookery just outside Hallett Station")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch07#ch07fig03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilkes Station built on bedrock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch07#ch07fig04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ellsworth ships moored to Filchner Ice Shelf for off-loading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch07#ch07fig05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ellsworth Station under construction, February 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch09#ch09fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Launching a weather balloon against a fiery sunset at McMurdo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch11#ch11fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The deepest IGY pit at the Wilkes Icecap Station (Site 2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch11#ch11fig03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traverse Sno-Cat outfitted with crevasse detector")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch11#ch11fig04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Navy Otter arriving to resupply Ellsworth IGY traverse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch11#ch11fig05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instruments measure crevasse movement, Ice Deformation Study")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch11#ch11fig06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Members of Ellsworth traverse party"), _c('br'), _vm._v("conducting glaciology studies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch12#ch12fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finn Ronne, station leader, playing bridge with IGY scientists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/ch12#ch12fig02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking up McMurdo’s Forrestal Avenue toward"), _c('br'), _vm._v("the Chapel of the Snows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/app01#app01fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author with Antarctic Deep Freeze Association partners"), _c('br'), _vm._v("at VXE-6 disestablishment ceremonies, March 1999")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02f22850","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pref03.vue
// module id = 81
// module chunks = 0